// import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import globalAppConfig from "@/app.config.global.js"

// Vue.prototype.$vuetify.theme = {
//     primary: '#3f51b5',
//     secondary: '#b0bec5',
//     accent: '#8c9eff',
//     error: '#ff00ff'
//   };
// $lyb-blue: rgb(0,156,222);//#009CDE;
// $lyb-dark: rgb(66, 85, 99);//#425563;

// $lyb-dkblue: rgb(0, 0, 128);//#000080;
// $lyb-pink: rgb(219, 62, 177);//#DB3EB1;
// $lyb-green: rgb(132, 189, 0);//#84BD00;
// $lyb-orange: rgb(255, 130, 0);//#FF8200;
// $lyb-red: rgb(173, 0, 12);//#AD000C;
// $lyb-gray: rgb(204, 204, 204);//#CCC;

 
Vue.use(Vuetify);

export default new Vuetify({
    theme : {
        dark : globalAppConfig.darkModeDefault,
        themes : {
            dark : {
                primary: '#eee',
                secondary: '#425563',
                accent: '#FF4081',
                error: '#DB0B5B',
                info: '#009CDE',
                success: '#68a200',
                warning: '#bf4e00',
                red: '#AD000C',
                pink: '#DB3EB1',
                blue: '#009CDE',
                darkblue: '#000080',
                green: '#84BD00',
                grey: '#425563',
            },
            light : {
                primary: '#004ED4',
                secondary: '#425563',
                accent: '#FF4081',
                error: '#DB0B5B',
                info: '#009CDE',
                success: '#68a200',
                warning: '#bf4e00',
                red: '#AD000C',
                pink: '#DB3EB1',
                grey: '#727680',
                blue: '#004ED4',
                navy: '#001743',
                green: '#00A14B',
                magenta: "#DB0B5B",
                lightblue: "#DEF6FF",
                cyan: "#00B5E2",
                orange: "#F27D00",
                white: "#FFFFFF",
                lighterblue: "#90B6FF",
            },
        }
    }
});
